class Countdown {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            ...JSON.parse(elem.getAttribute('data-countdown') || '{}')
        }
    }

    onInit () {
        this.interval = setInterval(this._getCountdown.bind(this), 1000)
    }

    _getCountdown () {
        const location = this._data.location
        const daylightSaving = this._data.daylight_saving
        let timezone = 'GMT'

        if (location === 'AU') {
            // AEST + 10
            timezone = 'AEST'
        } else if (location === 'EU') {
            // CET + 2
            timezone = 'CET'
        } else if (location === 'US') {
            // EST - 4
            timezone = 'EST'
        } else {
            // bst + 1
            // GMT + 0
            timezone = (daylightSaving === 'true' ? 'BST' : 'GMT')
        }

        const remaining = this._getTimeRemaining(this._data.sale_end, timezone)
        const html = this._buildHtml(remaining, timezone)

        this._elem.innerHTML = html
    }

    _buildHtml (remaining, timezone) {
        return `
        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">DAYS</span>
            <span class="countdown__unit tablet-only">DAYS</span>
            <span class="countdown__time">${remaining.days}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">HOURS</span>
            <span class="countdown__unit tablet-only">HRS</span>
            <span class="countdown__time">${remaining.hours}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">MINUTES</span>
            <span class="countdown__unit tablet-only">MIN</span>
            <span class="countdown__time">${remaining.minutes}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">SECONDS</span>
            <span class="countdown__unit tablet-only">SEC</span>
            <span class="countdown__time">${remaining.seconds}</span>
        </div>
        <div class="countdown__timezone flex f-dir-column text-align-center f-space-end">
            <span class="countdown__unit">${timezone}</span>
        </div>
        `
    }

    _getTimeRemaining (endtime, timezone) {
        const a = endtime.split(' ')
        const d = a[0].split('-')
        const t = a[1].split(':')

        const targetDay = d[0]
        const targetMonth = d[1]
        const targetYear = d[2]

        const targetHour = t[0]
        const targetMinute = t[1]

        // Convert BST to UTC
        const utc = new Date(Date.UTC(targetYear, targetMonth - 1, targetDay, targetHour, targetMinute)).getTime()

        let targetTimestamp = utc / 1000
        if (timezone === 'AEST') {
            // AEST + 10
            targetTimestamp = this._addHours(utc, 10)
        } else if (timezone === 'CET') {
            // CET + 2
            targetTimestamp = this._addHours(utc, 2)
        } else if (timezone === 'EST') {
            targetTimestamp = this._addHours(utc, -4)
        } else if (timezone === 'BST') {
            // bst + 1
            targetTimestamp = this._addHours(utc, 1)
        } else {
            targetTimestamp = targetTimestamp * 1000
        }

        const total = targetTimestamp - Date.now()

        if (total < 0) {
            return {
                'hours': 0,
                'minutes': 0,
                'seconds': 0,
                'days': 0
            }
        }

        let seconds = Math.floor((total / 1000) % 60)
        let minutes = Math.floor((total / 1000 / 60) % 60)
        let hours = Math.floor((total / (1000 * 60 * 60)) % 24)
        let days = Math.floor(total / (1000 * 60 * 60 * 24))

        if (seconds < 10) seconds = '0' + seconds
        if (minutes < 10) minutes = '0' + minutes
        if (hours < 10) hours = '0' + hours
        if (days < 10) days = '0' + days

        return {
            hours,
            minutes,
            seconds,
            days
        }
    }

    _addHours (ts, h) {
        return ts + (h * 60 * 60 * 1000)
    }
}

export default Countdown



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Countdown.js